export function formatMessage(reason: string | null, practitionerName: string | null, recordedDate: string | null) {
    let message = '';

    if (reason) {
        message = reason;
    }

    if (practitionerName) {
        message += `${message ? ', ' : ''}` + practitionerName;
    }

    if (recordedDate) {
        message += `${message ? ', ' : ''}` + recordedDate;
    }

    return message ? `(${message})` : message;
}
